import { FormikErrors } from 'formik';
import { ApiResponseError } from '@round/api';
import countries from './countries';

export function mapApiErrorsToFormikErrors<T extends Record<string, any>>(
    apiErrors: ApiResponseError<T>
): FormikErrors<T> {
    return Object.keys(apiErrors).reduce((formikErrors, key) => {
        const value = apiErrors[key as keyof ApiResponseError<T>];
        return {
            ...formikErrors,
            [key]: typeof value === 'string' ? value : value?.join(''),
        };
    }, {} as FormikErrors<T>);
}

export function downloadFile(file: File) {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(file);
    a.setAttribute('download', file.name);
    a.click();
}

export type Country = {
    label: string;
    code: string;
};

export const getCountry = (countryCode: string | undefined | null): Country | null => {
    if (!countryCode) {
        return null;
    }

    const label = countries[countryCode] || null;

    if (!label) {
        return null;
    }

    return {
        label,
        code: countryCode,
    };
};

export function formatToIsoDateString(date: Date) {
    // Adjusting date to UTC to avoid timezone issues
    const adjustedDate = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes())
    );
    return adjustedDate.toISOString().split('T')[0];
}

export const isUrl = (url: string) => {
    // eslint-disable-next-line
    return new RegExp(/^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/).test(url);
};
